import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { ToasterService } from '../../../shared/services/toaster/toaster.service';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.scss']
})
export class ResetComponent implements OnInit {

  public user_new_password: string = '';
  public user_confirm_password: string = ''; // To store the confirm password input
  public show_password: boolean = false;
  public loading: boolean = false;
  public token: string = ''; // To store the token from the URL

  constructor(
    private Router: Router,
    private ActivatedRoute: ActivatedRoute,
    private Auth_Service: AuthService,
    private Toaster: ToasterService,
  ) { }

  ngOnInit(): void {
    this.token = this.ActivatedRoute.snapshot.queryParams['token'];
    if (!this.token) {
      this.Toaster.warning('Something went wrong. Please re-initiate the password reset process.');
      this.Router.navigate(['/auth/login']);
      return;
    }

    // Check if the token is expired
    const tokenExpiration = this.Auth_Service.getTokenExpiration(this.token); // Assuming this method exists
    if (tokenExpiration && tokenExpiration < new Date()) {
      const minutesAgo = Math.floor((new Date().getTime() - tokenExpiration.getTime()) / 60000);
      this.Toaster.warning(`The reset token expired ${minutesAgo} minutes ago. Please re-initiate the password reset process.`);
      this.Router.navigate(['/auth/login']);
    }
  }

  public async reset() {
    this.loading = true;
    try {
      // Guard against missing credentials
      if (!this.user_new_password) throw `Missing new password`;
      if (!this.user_confirm_password) throw `Missing confirm password`;
      // Check if passwords match
      if (this.user_new_password !== this.user_confirm_password) {
        this.Toaster.warning('Passwords do not match.');
        return;
      }
      // Make API call to reset password
      const success = await this.Auth_Service.resetPasswordWithToken(this.token, this.user_new_password);
      if (success) {
        this.Toaster.success('Password reset successfully!');
        // Redirect user to login
        this.Router.navigate(['/auth/login']);
      } else {
        this.Toaster.warning('Failed to reset password. Please try again.');
      }
    } catch (error) {
      this.Toaster.warning(`Password reset error: ${error}`);
    } finally {
      this.loading = false;
    }
  }

}